import create, { StateCreator, StoreApi, UseBoundStore } from "zustand";

export interface CreateStore<T = Record<string, unknown>> extends UseBoundStore<StoreApi<T>> {
  reset: () => void;
}

export const createStore = <T>(createState: StateCreator<T>) => {
  const store = create<T>(createState);
  const initialState = store.getState();

  ((store as unknown) as CreateStore<T>).reset = () => store.setState(initialState, true);

  return (store as unknown) as CreateStore<T>;
};
